import { service } from '@/ajax/request'

export const presCategoryTypeListPlus = (params: any) => {
    return service({
        url: `/prescription/presCategory/pageByType`,
        method: 'POST',
        params,
    })
}

export const presCategoryTypeList = (params: any) => {
    return service({
        url: `/prescription/presCategory/listByType/${params.categoryType}`,
        method: 'POST',
        params,
        type: "form"
    })
}

export const saveOrUpdatePresCategory = (params: any) => {
    return service({
        url: `/prescription/presCategory/saveOrUpdate`,
        method: 'POST',
        params,
        type: 'string',
    })
}

export const prescriptionSymptom = (params: any) => {
    return service({
        url: `/prescription/prescription/querySymptom/${params.libCode}`,
        method: 'POST',
        params,
        type: 'form',
    })
}

export const prescriptionLoadPres = (symptomId: any, merchantId: string | number) => {
    return service({
        url: `/prescription/prescription/loadPres/${symptomId}${merchantId ? `/${merchantId}` : ""}`,
        method: 'POST',
    })
}

export const prescriptionSaveOrUpdate = (params: any) => {
    return service({
        url: `/prescription/prescription/saveOrUpdate`,
        method: 'POST',
        params,
        type: 'string'
    })
}

export const prescriptionDisable = (id: any) => {
    return service({
        url: `/prescription/prescription/disable/${id}`,
        method: 'POST',
        type: 'string'
    })
}

export const getCategoryList = (parentId: any, merchantId) => {
    return service({
        url: `/prescription/presCategory/loadPresCategory/${parentId}`,
        method: 'POST',
        params: { merchantId },
        type: "form"
    })
}

export const getCategoryDetail = (id) => {
    return service({
        url: `/prescription/presCategory/getById/${id}`,
        method: 'POST',
    })
}

// 品牌方处方库列表
export const getMerchantList = (params) => {
    return service({
        url: `/prescription/merchant/query`,
        method: 'POST',
        params
    })
}
// 品牌方处方 查询门店下拉
export const queryStore = (params) => {
    return service({
        url: `/prescription/merchant/queryStore`,
        method: 'POST',
        params
    })
}
// 品牌方处方 查询门店下拉
export const saveOrUpdateMerchant = (params) => {
    return service({
        url: `/prescription/merchant/saveOrUpdate`,
        method: 'POST',
        params
    })
}
// 品牌方 启用禁用
export const changeMerchantStatus = (params) => {
    return service({
        url: `/prescription/merchant/changeStatus/${params.id}/${params.status}`,
        method: 'POST'
    })
}
// 获取品牌方小程序配置
export const brandMiniConfig = (merchantId) => {
    return service({
        url: `/merchantapp/merchantApp/getMerchantApp?merchantId=${merchantId}`,
        method: 'GET'
    })
}
// 保存品牌方小程序配置
export const saveBrandMiniConfig = (params) => {
    return service({
        url: `/merchantapp/merchantApp/saveOrUpdate`,
        method: 'POST',
        params
    })
}

// 获取默认品牌方小程序配置参数
export const getDefaultMerchantApp = () => {
    return service({
        url: `/merchantapp/merchantApp/getAppTemplateInfo`,
        method: 'GET',
    })
}

// 获取saas产品列表
export const saasServiceList = (params) => {
    return service({
        url: `/saasservicemapping/saasServiceProduct/getSaasServiceList`,
        method: 'POST',
        params
    })
}

// 获取saas产品列表
export const saasServiceProduct = (params) => {
    return service({
        url: `/saasservicemapping/saasServiceProduct/add`,
        method: 'POST',
        params,
    })
}

// 获取养身帮Saas服务对应列表
export const saasServiceProductList = (params) => {
    return service({
        url: `/saasservicemapping/saasServiceProduct/list`,
        method: 'POST',
        params,
    })
}

export const saasServiceProductDel = (params) => {
    return service({
        url: `/saasservicemapping/saasServiceProduct/delete`,
        method: 'POST',
        params,
    })
}

export const presCategoryProductQuery = (params) => {
    return service({
        url: `/prescription/presCategory/productQuery`,
        method: "POST",
        params,
    })
}

export const getProductCategoryList = (params) => {
    return service({
        url: `/mall/mall-product-category/list`,
        method: "POST",
        params,
    })
}

export const getProductList = (params) => {
    return service({
        url: `/mall/mall-product/list`,
        method: "POST",
        params,
    })
}

export const saveOrUpdateMallProduct = (params) => {
    return service({
        url: `/prescription/presCategory/saveOrUpdateMallProduct`,
        method: "POST",
        params,
    })
}

export const getProductName = (params) => {
    return service({
        url: `/prescription/presCategory/product`,
        method: "POST",
        params,
        type: "form"
    })
}

export const saasStoreList = (params) => {
    return service({
        url: `/saasservicemapping/saasServiceProduct/get-store-saas-list`,
        method: "POST",
        params
    })
}

export const saasServiceDisable = (params) => {
    return service({
        url: `/saasservicemapping/saasServiceProduct/en-disable`,
        method: "POST",
        params
    })
}

export const updatePresCategoryStatus = (params) => {
    return service({
        url: `/prescription/presCategory/updateStatus`,
        method: "POST",
        params
    })
}

export const getPresCategoryList = (params) => {
    return service({
        url: `/prescription/presCategory/selectPresCategory`,
        method: "POST",
        params
    })
}

export const getMerchantDetail = (id) => {
    return service({
        url: `/prescription/merchant/getById/${id}`,
        method: 'POST',
    })
}

export const getMerchant = (params) => {
    return service({
        url: `/prescription/merchant/choiceMerchantId`,
        method: 'POST',
        params
    })
}

// 品牌分账门店列表
export const getMerchantBuyList = (params) => {
    return service({
        url: `/prescription/merchant/merchant-buy-list`,
        method: 'POST',
        params
    })
}

export const getProductClassifyList = (params) => {
    return service({
        url: `/prescription/presCategory/choiceMallProduct`,
        method: 'POST',
        params
    })
}

export const getUpdateBatchPage = (params) => {
    return service({
        url: `/prescription/presCategory/updateBatchPage`,
        method: 'POST',
        params
    })
}

export const updateBatchStatus = (params) => {
    return service({
        url: `/prescription/presCategory/updateBatchStatus`,
        method: 'POST',
        params
    })
}

export const getHealthExamineList = (params) => {
    return service({
        url: `/healthexamine/healthExamineProfile/getHealthExamineList`,
        method: 'POST',
        params
    })
}

export const getYsbStoreList = (params) => {
    return service({
        url: `/mall/mall-banner/selectYsbStore`,
        method: 'POST',
        params
    })
}

export const prescriptionCopy = (params: any) => {
    return service({
        url: `/prescription/prescription/copy`,
        method: 'POST',
        params
    })
}

// 复制处方库-获取来源品牌方列表
export const getSourceMerchants = (params: any) => {
    return service({
        url: `/prescription/prescription/getSourceMerchants`,
        method: 'POST',
        params
    })
}

// 处方模块名称配置-列表
export const prescriptionModuleNameList = (params: any) => {
    return service({
        url: `/prescription/moduleName/list?merchantId=${encodeURIComponent(params.merchantId)}`,
        method: 'POST'
    })
}

// 处方模块名称配置-保存
export const savePrescriptionModuleName = (params: any) => {
    return service({
        url: `/prescription/moduleName/save`,
        method: 'POST',
        params
    })
}

// 处方库单位配置-列表（全量，含已关闭）
export const prescriptionProductUnitList = () => {
    return service({
        url: `/prescription/productUnit/list`,
        method: 'POST'
    })
}

// 处方库单位配置-新增
export const savePrescriptionProductUnit = (params: { unitName: string }) => {
    return service({
        url: `/prescription/productUnit/save`,
        method: 'POST',
        params
    })
}

// 处方库单位配置-开关
export const switchPrescriptionProductUnit = (params: { id: number; enabled: number }) => {
    return service({
        url: `/prescription/productUnit/switch`,
        method: 'POST',
        params
    })
}

// 处方编辑下拉使用的启用单位，多个处方组件实例共用一次请求
let enabledProductUnitPromise: Promise<any[]> | null = null

export const getEnabledProductUnits = (): Promise<any[]> => {
    if (!enabledProductUnitPromise) {
        enabledProductUnitPromise = prescriptionProductUnitList().then((res: any) => {
            return (res.data || []).filter((item: any) => item.enabled === 1)
        }).catch((error: any) => {
            // 失败后不缓存，下次进页面可以重试
            enabledProductUnitPromise = null
            return Promise.reject(error)
        })
    }
    return enabledProductUnitPromise
}

// 配置变更后清缓存，处方编辑页下次进入时重新获取
export const clearEnabledProductUnitCache = () => {
    enabledProductUnitPromise = null
}
